'use strict';
var util = require('../util');

module.exports = {
  appVersion: '7.9.2',
  
  previewImage: util.actionMapping('previewImage')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/dpapp/lib/patch/patch-7.9.2.js
// module id = Hb8p
// module chunks = 0